import { Navigate, useLocation } from "react-router-dom";
import { authService } from "../../../lib/api/apiService";
import useCurrentUser from "../../../hooks/useCurrentUser";

const getFallbackRoute = (role) => {
  switch (role) {
    case "ADMIN":
      return "/admin-dashboard";
    case "SELLER":
      return "/dashboard";
    default:
      return "/";
  }
};

const RequireRole = ({ allowedRoles, children }) => {
  const location = useLocation();
  const isAuthenticated = authService.isAuthenticated();
  const { data: user, isLoading } = useCurrentUser();

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/vendor/login"
        replace
        state={{ from: location }}
      />
    );
  }

  if (isLoading) {
    return null;
  }

  if (!user) {
    return (
      <Navigate
        to="/vendor/login"
        replace
        state={{ from: location }}
      />
    );
  }

  if (!allowedRoles.includes(user.role)) {
    return <Navigate to={getFallbackRoute(user.role)} replace />;
  }

  return children ?? null;
};

export default RequireRole;
